export function showInfoLabel(text, time = 2000) {
    $('.info-label').fadeIn().find('.info-label__text').text(text);
    return new Promise(resolve => setTimeout(function () {
        $('.info-label').fadeOut();
        resolve();
    }, time));
}
